/**
 * Auth0 Configuration
 * Two separate Auth0 applications for doctors and parents
 */

export const AUTH0_DOMAIN = 'dev-fwyfo7oqr5cn8zxi.us.auth0.com';

// API identifier - set to empty string if you haven't created an API in Auth0 yet
// To use JWT access tokens, create an API in Auth0 with this identifier
export const AUTH0_AUDIENCE = '';  // Set to 'https://vaccine-tracker-api' after creating the API

// Doctor application client ID
export const AUTH0_DOCTOR_CLIENT_ID = 'Ww5hzDz0RIaklaqsXGXReuLBJIFzSyQR';

// Parent application client ID
export const AUTH0_PARENT_CLIENT_ID = 'mIFCD8yGVy0yoS4nXzx5Z8t0muX6LnUP';

// Passwordless connection names (adjust if you renamed them in Auth0)
// Common default for email passwordless is 'email'. If you created
// separate connections per app, set those names here.
export const AUTH0_DOCTOR_CONNECTION = 'email';
export const AUTH0_PARENT_CONNECTION = 'email';
